import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3295de40"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col-12 bg-white rounded-4 shadow p-0 m-0 mt-5" }
const _hoisted_2 = { class: "m-4" }
const _hoisted_3 = { class: "fw-bold" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_5 = { class: "text-center" }
const _hoisted_6 = {
  key: 0,
  class: "reload-error"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-secondary",
  role: "status"
}, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-redo cursor-pointer fs-3 color-icon" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "invalid-error" }, "Error Api", -1))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = { class: "m-4" }
const _hoisted_13 = { class: "fs-75 mb-4" }
const _hoisted_14 = { class: "text-center" }
const _hoisted_15 = { class: "text-center" }
const _hoisted_16 = { class: "table-footer align-middle text-center" }
const _hoisted_17 = {
  key: 0,
  class: "text-center fw-bold"
}

import { translate } from '@/languages/i18n'
import Table from '@/components/table/DashBoardTable.vue'
import { onMounted, ref, watch, computed } from 'vue'
import { useRoute } from 'vue-router'
import communityDashboardService from '@/services/community-dashboard.services'
import { numberWithCommas } from '@/constants/common.ts'
import _ from 'lodash'


export default /*#__PURE__*/_defineComponent({
  props: {
  date: {
    type: Object,
  },
},
  setup(__props) {

const props = __props

const route = useRoute()
const listInvitationRoutes = ref([])
const loading = ref(false)
const errorCallApi = ref(false)

onMounted(() => {
  getDataInvitationRoutes()
})
watch(
  () => props.date?.from,
  () => {
    getDataInvitationRoutes()
  }
)
watch(
  () => props.date?.to,
  () => {
    getDataInvitationRoutes()
  }
)

const renderTotal = computed(() => {
  const total_applications = listInvitationRoutes.value.reduce((total, item) => total + item.number_of_applications, 0)
  const total_approvals = listInvitationRoutes.value.reduce((total, item) => total + item.number_of_approvals, 0)

  return {
    total_applications,
    total_approvals,
  }
})

const getDataInvitationRoutes = async () => {
  loading.value = true
  try {
    const res = await communityDashboardService.getInvitationRoutes(route.params.id, {
      from: props.date?.from ?? '',
      to: props.date?.to ?? '',
    })
    if (res.data?.success) {
      errorCallApi.value = false
      listInvitationRoutes.value = res?.data.data.labels
    } else {
      errorCallApi.value = true
    }
    loading.value = false
  } catch (error) {
    console.log(error)
    loading.value = false
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h6", _hoisted_3, _toDisplayString(_unref(translate)('CB10titleListInvitationRoutes')), 1)
    ]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
        : _createCommentVNode("", true),
      (!loading.value && errorCallApi.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            onClick: getDataInvitationRoutes,
            class: "reload-error"
          }, _hoisted_11))
        : _createCommentVNode("", true)
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_12, [
      _createElementVNode("p", _hoisted_13, _toDisplayString(_unref(translate)('CB10ListInvitationRoutesComment')), 1),
      _withDirectives(_createVNode(Table, {
        columns: [
          { field: 'invited_route_name', name: _unref(translate)('CB10invitationRouteName') },
          { field: 'number_of_applications', name: _unref(translate)('CB10numberOfApplications') },
          { field: 'number_of_approvals', name: _unref(translate)('CB10numberOfApprovals') },
        ],
        idTable: 'invitationRoutesTable'
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listInvitationRoutes.value, (item, index) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: index,
              class: _normalizeClass({ rowEven: index % 2 === 0 })
            }, [
              _createElementVNode("td", null, _toDisplayString(item?.invited_route_name), 1),
              _createElementVNode("td", _hoisted_14, _toDisplayString(_unref(numberWithCommas)(item?.number_of_applications)), 1),
              _createElementVNode("td", _hoisted_15, _toDisplayString(_unref(numberWithCommas)(item?.number_of_approvals)), 1)
            ], 2))
          }), 128)),
          _createElementVNode("tr", _hoisted_16, [
            _createElementVNode("td", null, _toDisplayString(_unref(translate)('CB10footerTotal')), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(renderTotal).total_applications), 1),
            _createElementVNode("td", null, _toDisplayString(_unref(renderTotal).total_approvals), 1)
          ])
        ]),
        _: 1
      }, 8, ["columns"]), [
        [_vShow, !loading.value]
      ]),
      (listInvitationRoutes.value?.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_unref(translate)('CB10NoData')), 1))
        : _createCommentVNode("", true)
    ], 512), [
      [_vShow, !loading.value && !errorCallApi.value]
    ])
  ]))
}
}

})